// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__301W-","left":"StickyBox_left__Pk1rc","right":"StickyBox_right__2Af1X"};